// extracted by mini-css-extract-plugin
module.exports = {"switch":"OnOffSwitcher_switch__2OXbJ","slider":"OnOffSwitcher_slider__32c2B","round":"OnOffSwitcher_round__1KBFQ","OnOffSwitcher":"OnOffSwitcher_OnOffSwitcher__ekQDQ"};